import zIndex from '@material-ui/core/styles/zIndex';
import { launch } from '../../shared/helper/serviceLauncher';
import { makeStyles } from "@material-ui/core";

const CardServico = (props) => {

  const classes = useStyles();

  const grupo = props.grupo;

  const maxColumns = (() => {
    switch (props.maxColumns) {
      case 1:
        return 'oneColumn'
      case 2:
        return 'twoColumns'
      case 3:
        return 'threeColumns'
      default:
        return 'threeColumns'
    }
  })();

  const handleClick = (servico) => {
    if (servico.callback){
      servico.callback();
      return;
    }

    launch(servico);
  }

  const handleKeyDown = (e, callback) => {
    if (e.key === 'Enter') {
      callback();
    }
  }

  return (
    <div style={{ width: "100%" }}>
      {
        !!grupo.titulo &&
        <h2 className={classes.tituloGrupo}>
          {grupo.titulo}
        </h2>
      }
      <div className={`${classes.divGrupoServicos} ${classes[maxColumns]}`}>
        {!!props.servicos && !!props.servicos.length && props.servicos.map((s, j) => {
          if (s && (s.isAtivo == true || s.ativo == true)) {
            return (
              <div
                key={j+1}
                onClick={(e) => handleClick(s)}
                onKeyUp={(e) => {
                  handleKeyDown(e, () => handleClick(s))
                }}
                tabIndex={0}
                role="button"
                className={`${classes.cardServico} ${props.xsOneColumn ? classes.cardServicoAlt : ''}`}>
                <div
                  style={{ backgroundColor: grupo.backgroundColor }}
                  className={classes.divIconeCardServico}
                ><i style={{ color: grupo.color }} className={`${s.icone || s.icon} ${classes.iconeCardServico}`}></i></div>
                <div className={classes.tituloCardServico}>{s.tituloCurto || s.titulo}</div>
                {s.isDestaqueNovoServico &&
                  <div className={classes.badgeDestaque}>Novo</div>
                }
              </div>
            )
          }
        })}
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  badgeDestaque: {
    backgroundColor: "rgb(22, 136, 33)",
    position: "absolute",
    top: "0",
    right: "0",
    borderRadius: "4px",
    color: "white",
    width: "33px",
    height: "16px",
    fontSize: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tituloGrupo: {
    fontWeight: '600 !important', 
    margin: '16px 0 16px 0 !important', 
    padding: '0 !important',
    fontSize: '1.2em !important'
  },
  divGrupoServicos: {
    display: "grid",
    gap: "8px",
    paddingBottom: "4px",
  },
  threeColumns: {
    gridTemplateColumns: "repeat(3, 1fr)",
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    }
  },
  twoColumns: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  oneColumn: {
    gridTemplateColumns: "repeat(1, 1fr)",
  },
  cardServico: {
    backgroundColor: theme.palette.mode === 'dark' ? '#000' : '#fff',
    alignItems: 'center',
    borderRadius: '5px',
    boxShadow: "0px 2px 4px #00000040",
    cursor: 'pointer',
    display: 'flex',
    fontSize: '1.2em',
    [theme.breakpoints.down('sm')]: {
      height: '4.571em',
      fontSize: '1em',
    },
    height: '4.286em', //'72px',
    justifyContent: 'start',
    position: 'relative',
    paddingRight: "8px",
    '&:hover': {
      backgroundImage: "linear-gradient(rgba(51,51,51,0.16), rgba(51,51,51,0.16))",
    },
    '&:focus': {
      boxShadow: '0 0 0 2px #c2850c',
      border: '1px solid #c2850c',
      outline: 'none'
    }
  },
  cardServicoAlt: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  divIconeCardServico: {
    display: 'flex',
    padding: '0px 8px',
    margin: '0px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: "100px",
    width: "34px",
    height: "34px",
    backgroundColor: theme.palette.mode === 'dark' ? 'transparent !important' : '' 
  },
  iconeCardServico: {
    fontSize: '20px',
    color: theme.palette.mode === 'dark' ? 'white !important' : '' 
  },
  tituloCardServico: {
    color: theme.palette.mode === 'dark' ? '#fff333' : '#000',
    textDecoration: theme.palette.mode === 'dark' ? 'underline' : 'none',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    fontSize: '1em',
  },
}))

export default CardServico;
